import { SelectSubscriptionForm } from "../components/select-subscription-form";

export function SelectSubscriptionPage() {
  return <SelectSubscriptionForm />;
}
